///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { userRole, mode as modeType, repType } from "./types";

const isOwnerOfBidMode = (bidModes, bidModeType, bidOwnerRepType) => {
  if (
    bidModes.find(({ mode }) => mode === bidModeType)?.bidOwnerRepType ===
    bidOwnerRepType
  ) {
    return true;
  } else {
    return false;
  }
};

export const isAuthorizedToView = (role, bidModes) => {
  switch (role) {
    case userRole.salesRep:
      return isOwnerOfBidMode(bidModes, modeType.tl, repType.sales);
    case userRole.tlPricingAnalyst:
    case userRole.assetBasedPricingUser:
      return bidModes.find(({ mode }) => mode === modeType.tl)?.bidOwnerRepType
        ? true
        : false;
    case userRole.ltlPricingAnalyst:
      return isOwnerOfBidMode(bidModes, modeType.ltl, repType.pricing);
    case userRole.imdlPricingAnalyst:
      return isOwnerOfBidMode(bidModes, modeType.imdl, repType.pricing);
    default:
      return false;
  }
};

export default isAuthorizedToView;
